import * as React from 'react';

export const Row = (props: React.HTMLProps<HTMLDivElement>) =>
	<div {...props} className={`row ${props.className || ''}`} >{props.children}</div>;


export type ColumnSize = 'one-quarter' | 'one-third' | 'two-thirds' | 'one-half' | 'three-quarters' | 'full';

interface ColumnProps extends React.HTMLProps<HTMLDivElement> {
	// Me gustaría llamarlo size en lugar de width, pero no puedo porque ya existe en HTMLProps
	width: ColumnSize;
	offset?: ColumnSize;
}

export const Column = (props: ColumnProps) => {

	const width = {
		'one-quarter': 'col-xs-12 col-sm-3 col-md-3 col-lg-3',
		'one-third': 'col-xs-12 col-sm-4 col-md-4 col-lg-4',
		'two-thirds': 'col-xs-12 col-sm-8 col-md-8 col-lg-8',
		'one-half': 'col-xs-12 col-sm-6 col-md-6 col-lg-6',
		'three-quarters': 'col-xs-12 col-sm-9 col-md-9 col-lg-9',
		'full': 'col-xs-12 col-sm-12 col-md-12 col-lg-12'
	};

	const offset = {
		'one-quarter': 'col-sm-offset-3 col-md-offset-3 col-lg-offset-3',
		'one-third': 'col-sm-offset-4 col-md-offset-4 col-lg-offset-4',
		'two-thirds': 'col-sm-offset-8 col-md-offset-8 col-lg-offset-8',
		'one-half': 'col-sm-offset-6 col-md-offset-6 col-lg-offset-6',
		'three-quarters': 'col-sm-offset-9 col-md-offset-9 col-lg-offset-9',
		'full': ''
	};

	const theOffset = props.offset && offset[props.offset] || '';

	return <div {...props} className={`${width[props.width]} ${theOffset} ${props.className || ''}`}>{props.children}</div>;
};
